module.exports = "/packs/course-small-pr-024870379129c6d90eddc71e8a83cc3c.png";